import React from 'react';

import Row from 'components/data-visualization/Table/Row';

import {
  StyledEntityItem,
  VersionsButton,
  NumVersionCell,
  CaretVersions,
  EntityCell,
} from './ViewRelatedMenu.styles';

interface ITableRowProps {
  entity: any;
  entityData: any;
  onVersionClick: any;
  isVersionType: boolean;
  isHighlighted?: boolean;
}

const TableRow: React.FC<ITableRowProps> = (props) => {
  const {
    entity,
    entityData,
    onVersionClick,
    isVersionType,
    isHighlighted,
  } = props;

  return (
    <Row>
      <EntityCell width="100%">
        <StyledEntityItem
          entityId={entity.id}
          entityType={entity.type}
          displayName={entity.displayName}
          primaryArtist={entity.primaryArtist}
          thumbnailUrl={entity.thumbnailUrl}
          releaseDate={entity.releaseDate}
          isGroup={entity.is_group}
          parentEntityId={entity.parent_group_id}
          groupChildCount={entity.group_child_count}
          entityData={entityData}
          releaseCount={entity.grouped_album_count}
          artistCount={entity.artist_count}
          trackCount={entity.grouped_track_count}
          isHighlighted={isHighlighted}
          releaseType={entity?.productType}
          isrc_list={entity.isrc_list}
          preserveSearch
          isLink
        />
      </EntityCell>
      {!isVersionType && (
        <NumVersionCell>
          {entity.group_child_count > 1 && (
            <VersionsButton
              onClick={(): any =>
                onVersionClick(entity.id, entity.type, entity.group_child_count)
              }
            >
              {entity.group_child_count} versions <CaretVersions />
            </VersionsButton>
          )}
        </NumVersionCell>
      )}
    </Row>
  );
};

export default TableRow;
